import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import FormModalUpdatePrestaInfosEntreprise from "../FormModalUpdatePrestaInfosEntreprise";
import "./profil.css";
import FormModalUpdatePrestaInfosPerso from "../FormModalUpdatePrestaInfosPerso";
import { fetchProfilPrestataire } from "../../redux/actions/profilActions";
import FormModalUpdatePresentationPresta from "../FormModalUpdatePresentationPresta";
import GoogleMapView from "../GoogleMapView";
import FormModalUpdateLocalisationPresta from "../FormModalUpdateLocalisationPresta";
import useIsMobile from "../../hooks/useIsMobile";
import GestionCompetencesPresta from "../GestionCompetencesPresta";
import GestionRealisationsPresta from "../GestionRealisationsPresta";
import { logout } from "../../redux/actions/authActions";

export default function ProfilPrestataire() {
    const dispatch = useDispatch();
    const { user, token } = useSelector((state) => state.auth);
    const { prestataire } = useSelector((state) => state.profil);
    const navigate = useNavigate();

    const apiUrl = process.env.REACT_APP_API_URL;

    // ❗Ce hook doit être avant tout "return"
    const isMobile = useIsMobile(768);

    // ❗Tous les useState doivent être ici (avant tout if(return))
    const [showFormUpdate, setShowFormUpdate] = useState(false);
    const [showFormUpdateInfos, setShowFormUpdateInfos] = useState(false);
    const [showFormUpdatePresentationPresta, setShowFormUpdatePresentationPresta] = useState(false);
    const [showFormUpdateLocalisationPresta, setShowFormUpdateLocalisationPresta] = useState(false);

    const [activeTab, setActiveTab] = useState("infos");
    const [openAccordion, setOpenAccordion] = useState(null);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const handleDeleteUser = async () => {

        const confirmDelete = window.confirm(
            "Voulez-vous vraiment supprimer votre compte ? Cette action est irréversible."
        );

        if (!confirmDelete) return;

        try {
            const formData = new FormData();
            formData.append("idUser", user.idUser);
            const response = await fetch(`${apiUrl}/api/delete/account`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: formData,
            });

            const data = await response.json();

            if (!response.ok) {
                alert(data.error || "Erreur lors de la suppression");
                return;
            }

            alert("Votre compte a était supprimé avec succès");

            // Retour à la liste
            dispatch(logout());
            navigate("/");
            // Rafraîchir la liste

        } catch (error) {
            console.error(error);
            alert("Erreur serveur");
        }
    };
    // ❗useEffect aussi doit être au-dessus
    useEffect(() => {
        if (!user || !token) {
            navigate("/");
        } else {
            dispatch(fetchProfilPrestataire(token));
        }
    }, [user, token, navigate, dispatch]);

    // 🔥 Seulement maintenant : on peut retourner null
    if (!prestataire) return null;

    const getNameStatut = (idStatut) => {
        switch (idStatut) {
            case "micro-entrepreneur":
                return "Micro-entrepreneur (ME)";
            case "eirl":
                return "Entreprise Individuelle (EI)";
            default:
                return idStatut.toUpperCase();
        }
    };

    const tabList = [
        { id: "infos", label: "Informations personnelles" },
        { id: "entreprise", label: "Mon entreprise" },
        { id: "presentation", label: "Présentation" },
        { id: "localisation", label: "Localisation" },
        { id: "competences", label: "Mes compétences" },
        { id: "realisations", label: "Mes réalisations" },

    ];

    return (
        <>
            <div className="profil-wrapper">
                {/* Desktop Tabs */}
                {!isMobile && (
                    <div style={{ display: "flex", gap: "12px", margin: "auto", justifyContent: "center" }}>
                        {tabList.map((tab) => (
                            <button
                                key={tab.id}
                                style={{
                                    padding: "8px 14px",
                                    cursor: "pointer",
                                    borderRadius: "6px",
                                    background: activeTab === tab.id ? "#007bff" : "#f1f1f1",
                                    color: activeTab === tab.id ? "white" : "#333",
                                    border: "none",
                                }}
                                onClick={() => setActiveTab(tab.id)}
                            >
                                {tab.label}
                            </button>
                        ))}

                    </div>
                )}

                {/* Mobile Dropdown */}
                {isMobile && (
                    <div style={{ marginTop: "20px", marginBottom: "15px" }}>
                        <button
                            style={{ padding: "10px", borderRadius: "6px", background: "#f1f1f1", width: "100%" }}
                            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                        >
                            {tabList.find((t) => t.id === activeTab)?.label} ▾
                        </button>
                        {mobileMenuOpen && (
                            <div style={{ marginTop: "10px", border: "1px solid #ddd", borderRadius: "6px", background: "#fafafa" }}>
                                {tabList.map((tab) => (
                                    <div
                                        key={tab.id}
                                        style={{ padding: "12px", cursor: "pointer" }}
                                        onClick={() => {
                                            setActiveTab(tab.id);
                                            setMobileMenuOpen(false);
                                        }}
                                    >
                                        {tab.label}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                )}

                <div className="profil-content">
                    {activeTab === "infos" && (
                        <div className="profil-section-card">
                            {prestataire?.photoProfilPrestataire && (
                                <div className="profil-photo-container">
                                    <img
                                        className="profil-photo"
                                        src={
                                            apiUrl +
                                            "/api/files/?categorie=photosPrestataires&file=" +
                                            prestataire?.photoProfilPrestataire
                                        }
                                        alt="Photo de profil"
                                    />
                                </div>
                            )}
                            <p><strong>Nom :</strong> {prestataire.lastNamePrestataire}</p>
                            <p><strong>Prénom :</strong> {prestataire.firstNamePrestataire}</p>
                            <p><strong>Date de naissance :</strong> {prestataire.dateNaissancePrestataire}</p>
                            <p><strong>Téléphone :</strong> {prestataire.telephonePrestataire}</p>
                            <p><strong>Site Web :</strong> {prestataire.siteWeb}</p>
                            <button className="btn-primary" onClick={() => setShowFormUpdateInfos(true)}>
                                MODIFIER
                            </button>
                            <button className="btn-primary" onClick={() => handleDeleteUser()}>
                                SUPPRIMER MON COMPTE
                            </button>
                        </div>
                    )}

                    {activeTab === "entreprise" && (
                        <div className="profil-section-card">
                            {prestataire?.logoPrestataire && (
                                <div className="profil-photo-container">
                                    <img
                                        className="profil-photo"
                                        src={
                                            apiUrl +
                                            "/api/files/?categorie=logos&file=" +
                                            prestataire?.logoPrestataire
                                        }
                                        alt="Logo"
                                    />
                                </div>
                            )}
                            <p><strong>Raison sociale :</strong> {prestataire.raisonSocialePrestataire}</p>
                            <p><strong>Secteur d'activité principal :</strong> {prestataire.secteur.labelSecteur}</p>
                            <p><strong>Statut :</strong> {getNameStatut(prestataire.statutPrestataire)}</p>
                            <p><strong>SIRET :</strong> {prestataire.siretPrestataire}</p>
                            {
                                !prestataire.isExempteTva && (
                                    <p><strong>TVA :</strong> {prestataire.numTvaPrestataire}</p>
                                )
                            }
                            {
                                prestataire.isExempteTva && (
                                    <p>Non assujetti à la TVA (Article 293 B du CGI)</p>
                                )
                            }


                            <button className="btn-primary" onClick={() => setShowFormUpdate(true)}>
                                MODIFIER
                            </button>
                        </div>
                    )}
                    {activeTab === "presentation" && (
                        <div className="profil-section-card">

                            <p><strong>Présentation :</strong> {prestataire.descriptionPrestataire}</p>
                            <p><strong>Intervention d'urgence 24h/24 7j/7 :</strong> {prestataire.isEmergencyInterventionPossible ? "OUI" : "NON"}</p>
                            <p><strong>Paiement CESU accepté :</strong> {prestataire.isCesuAccepted ? "OUI" : "NON"}</p>



                            <button className="btn-primary" onClick={() => setShowFormUpdatePresentationPresta(true)}>
                                MODIFIER
                            </button>
                        </div>
                    )}
                    {activeTab === "localisation" && (
                        <div className="profil-section-card">

                            <p><strong>Adresse :</strong> {prestataire.adressePrestataire}</p>
                            <p><strong>Code postal :</strong> {prestataire.codePostalPrestataire}</p>
                            <p><strong>Ville :</strong> {prestataire.villePrestataire}</p>
                            <p><strong>Pays :</strong> France</p>
                            <p><strong>Travail à distance uniquement :</strong> {prestataire.isDistanceOnly ? "OUI" : "NON"}</p>
                            {
                                !prestataire.isDistanceOnly && (
                                    <p><strong>Rayon d'intervention :</strong>{prestataire.rayonIntervention === 1000000 ? "Illimité" : " " + prestataire.rayonIntervention + " km"}</p>
                                )
                            }
                            <GoogleMapView origin={{ lat: prestataire.latitudePrestataire, lng: prestataire.longitudePrestataire }} />


                            <button className="btn-primary" onClick={() => setShowFormUpdateLocalisationPresta(true)}>
                                MODIFIER
                            </button>
                        </div>
                    )}
                    {
                        activeTab === "competences" && (
                            <GestionCompetencesPresta />
                        )
                    }
                    {
                        activeTab === "realisations" && (
                            <GestionRealisationsPresta />
                        )
                    }
                </div>
            </div>


            {showFormUpdate && (
                <FormModalUpdatePrestaInfosEntreprise onClose={() => setShowFormUpdate(false)} />
            )}
            {showFormUpdateInfos && (
                <FormModalUpdatePrestaInfosPerso onClose={() => setShowFormUpdateInfos(false)} />
            )}
            {
                showFormUpdatePresentationPresta && (
                    <FormModalUpdatePresentationPresta onClose={() => setShowFormUpdatePresentationPresta(false)} />
                )
            }
            {
                showFormUpdateLocalisationPresta && (
                    <FormModalUpdateLocalisationPresta onClose={() => setShowFormUpdateLocalisationPresta(false)} />
                )
            }
        </>
    );
}
